import { useMutation } from '@tanstack/react-query';
import API from 'api/API';

export const useSaveAllSetsInspections = () => {
  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.deliveries.saveAllSetsInspections>) =>
      API.deliveries.saveAllSetsInspections(...args),
  });
};
